// @flow

import { hpfetch } from '../util';

export const checkPromoted = (uid: string, hash: any) =>
  hpfetch(`promoted/check/`, {
    method: 'POST',
    body: JSON.stringify({ uid, hash }),
  });
